<script lang="ts">
  import * as Dialog from '$lib/components/ui/dialog';
  import type { ForwardTargets } from './api';

  // Unlike Messaging's picker, candidate destinations here are computed authoritatively by the
  // backend (CommentService::listForwardTargets) -- a conversation only appears if every one of
  // its participants has access to the source thread, and a thread only appears if it belongs to
  // the same subject -- so this just renders whatever comes back, no client-side filtering.
  export let open: boolean;
  export let targets: ForwardTargets | null;
  export let loading: boolean;
  export let onPickConversation: (conversationId: string) => void;
  export let onPickThread: (threadId: string) => void;

  function pickConversation(id: string) {
    onPickConversation(id);
    open = false;
  }

  function pickThread(id: string) {
    onPickThread(id);
    open = false;
  }
</script>

<Dialog.Root portal="#shadcn-ui-dialog-target" bind:open>
  <Dialog.Content class="max-w-sm">
    <Dialog.Header>
      <Dialog.Title>Forward to…</Dialog.Title>
    </Dialog.Header>
    {#if loading || !targets}
      <p class="m-0 text-sm text-muted-foreground">Loading…</p>
    {:else}
      <div class="flex max-h-80 flex-col gap-3 overflow-y-auto">
        {#if targets.threads.length > 0}
          <div>
            <div class="mb-1 text-xs font-medium uppercase text-muted-foreground">Other threads</div>
            {#each targets.threads as t (t.id)}
              <button type="button" class="block w-full rounded-md px-2 py-2 text-left text-sm hover:bg-muted" on:click={() => pickThread(t.id)}>
                {t.label}
              </button>
            {/each}
          </div>
        {/if}
        {#if targets.conversations.length > 0}
          <div>
            <div class="mb-1 text-xs font-medium uppercase text-muted-foreground">Conversations</div>
            {#each targets.conversations as c (c.id)}
              <button type="button" class="block w-full rounded-md px-2 py-2 text-left text-sm hover:bg-muted" on:click={() => pickConversation(c.id)}>
                {c.label}
              </button>
            {/each}
          </div>
        {/if}
        {#if targets.threads.length === 0 && targets.conversations.length === 0}
          <p class="m-0 text-sm text-muted-foreground">No valid forward destinations.</p>
        {/if}
      </div>
    {/if}
  </Dialog.Content>
</Dialog.Root>
